import { ComponentPropsWithoutRef, FC, useState } from 'react';
import styled from 'styled-components';
import { pxToRem } from '../../utils/pxToRem';
import { colors } from '../colors';

interface InputProps extends ComponentPropsWithoutRef<'input'> {
  errorMessage?: string;
  labelText: string;
}

interface InputWithIconProps extends InputProps {
  icon?: string;
}

export const Input: FC<InputProps> = ({
  labelText,
  errorMessage,
  className,
  ...rest
}) => {
  return (
    <Container className={className}>
      <InputLabel>{labelText}</InputLabel>
      <BasicInput error={!!errorMessage} {...rest} />
      {!!errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  );
};

export const InputWithIcon: FC<InputWithIconProps> = ({
  icon,
  labelText,
  errorMessage,
  className,
  type,
  ...rest
}) => {
  const [show, setShow] = useState(false);
  const handleShowText = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (type === 'password') {
      setShow((prev) => !prev);
    }
  };
  return (
    <Container className={className}>
      <InputLabel>{labelText}</InputLabel>
      <InputWrapper error={!!errorMessage}>
        <InputContainer type={show ? 'text' : type} {...rest} />
        <IconBtn onClick={handleShowText}>
          <IconContainer src={icon} alt="icon" />
        </IconBtn>
      </InputWrapper>
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </Container>
  );
};

export const Container = styled.div<{ error?: boolean }>`
  text-align: left;
  display: flex;
  flex-direction: column;
`;
export const InputLabel = styled.label<{ error?: boolean }>`
  color: ${colors.textDark};
  font-weight: 500;
  font-size: ${pxToRem(16)};
  line-height: 140%;
  text-align: left;
`;
export const BasicInput = styled.input<{ error?: boolean }>`
  background: ${colors.grey};
  border-radius: 8px;
  outline: transparent;
  border: 1px solid ${({ error }) => (error ? colors.danger : colors.greyText)};
  padding: 12px 16px;
  margin-top: 6px;

  &::placeholder {
    font-size: ${pxToRem(14)};
    color: ${colors.greyText};
  }
`;
const IconBtn = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
`;
export const ErrorMessage = styled.p`
  color: ${colors.danger};
  font-size: ${pxToRem(12)};
  margin-top: 8px;
  margin-left: 7px;
  line-height: ${pxToRem(14.4)};
`;

// input with icon styles
export const InputWrapper = styled.div<{ error?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${colors.grey};
  border-radius: 8px;
  border: 1px solid ${({ error }) => (error ? colors.danger : colors.greyText)};
  padding: 12px 16px;
  margin-top: 8px;
`;

export const InputContainer = styled.input`
  background: ${colors.grey};
  outline: none;
  border: none;
  flex: 1;

  &::placeholder {
    font-size: ${pxToRem(14)};
    color: ${colors.greyText};
  }
`;

export const IconContainer = styled.img`
  width: 15px;
  height: 15px;
`;
